module.exports = __webpack_public_path__ + "static/media/11.0f268d86.png";